module.exports = __webpack_public_path__ + "DejaVuSansMono-Oblique.a6927e438ac0588663bf.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/muhammadfiqihfirdiansyah/Documents/Muhammad Fiqih Firdiansyah/Project/Angular/BODES/BODES.Web.UI.Angular4/external_css/kendo-ui/fonts/DejaVu/DejaVuSansMono-Oblique.ttf?v=1.1
// module id = ../../../../../external_css/kendo-ui/fonts/DejaVu/DejaVuSansMono-Oblique.ttf?v=1.1
// module chunks = styles